import { defineStore } from 'pinia';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

let unsubscribeFn = null;

export const usePublicServiceStore = defineStore('publicService', {
  state: () => ({
    services: {},
    loading: false,
    error: ''
  }),
  persist: { paths: ['services'] },
  getters: {
    list(state) {
      const arr = Object.values(state.services);
      arr.sort((a, b) => (a.order ?? 999) - (b.order ?? 999) || (a.name || '').localeCompare(b.name || ''));
      return arr;
    }
  },
  actions: {
    subscribe() {
      if (unsubscribeFn) return;
      this.loading = true;
      this.error = '';
      const q = query(
        collection(firestore, 'services'),
        where('isPublic', '==', true)
      );
      unsubscribeFn = onSnapshot(
        q,
        (snap) => {
          this.loading = false;
          this.error = '';
          const next = {};
          snap.docs.forEach((docSnap) => {
            next[docSnap.id] = { id: docSnap.id, ...docSnap.data() };
          });
          this.services = next;
        },
        (err) => {
          this.loading = false;
          this.error = 'Não foi possível carregar os serviços.';
          console.warn('publicService onSnapshot error', err);
        }
      );
    },
    unsubscribe() {
      if (unsubscribeFn) {
        unsubscribeFn();
        unsubscribeFn = null;
      }
    }
  }
});
